<template>
  <div v-bind:id="targetId" class="flex-box fl-between content grab-bing targetContent" @mousedown="mouseDownEvent($event)"
  @mousemove="mouseMoveEvent($event, targetId)" @mouseleave="mouseUp($event)" @mouseup="mouseUp($event)" v-bind:class="{expandContent: expand}" >
        <div v-if="!expand" >
          <div class="objective_content">
            <read-more :text="data['contentText']" :addMore="false" :showMore="propShowMore" :contentHeight="propContentHeight" @update-show-more="updateShowMore" @update-content-height="updateContentHeight" :maxChars="18" :maxCharsSet="true">
              {{ data['contentText'] }}
            </read-more>
          </div>
          <div class="other_content">
            <div class="expandUserImages">
              <img v-for="(imageURL,index) of userImages" :key="index" class="img-circle" v-bind:style="{zIndex: (5-Number(index)), left: index*4+'px'}" style="position: absolute;"
                :src="imageURL">
            </div>
            <objective-knob class="node-knob" :progress="Number(data['progress'])" :readOnly="true" :width="45" :height="45"></objective-knob>
          </div>        
        </div>
        <div v-else class="expand-setknob">
          <div class="top_card">
            <objective-knob class="node-knobExpand" :progress="Number(data['progress'])" :readOnly="true" :width="70" :height="70"></objective-knob>
            <read-more class="expandText" :text="data['contentText']" :addMore="false" :showMore="propExpandShowMore" :contentHeight="propExpandContentHeight" @update-show-more="updateExpandShowMore" @update-content-height="updateExpandContentHeight">
              {{ data['contentText'] }}
            </read-more>
          </div>
          <div class="middle_card">
            <!-- <img src="https://firebasestorage.googleapis.com/v0/b/on1navi-1204.appspot.com/o/profilepictures%2FKJSwvx3zdmbk1PErgC6UrauQC3Z2%2F1575288849.jpg?alt=media&amp;token=3bcf093e-a630-4570-b23f-04aff01cb007" class="img-circle expand"> -->
            <div class="expandUserImages">
            <img v-for="(imageURL,index) of userImages" :key="index" class="img-circle" v-bind:style="{zIndex: (5-Number(index)), left: index*4+'px'}" style="position: absolute;"
                :src="imageURL">
            </div>
            <div class="date">
              <label class="startDate">開始日: {{ data['startDate'] }}</label>
              <label class="dueDate">期限: {{ data['dueDate'] }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
</template>

<script>
// import NoticeItem from '@/components/Notice/NoticeItem'
// import { mapActions, mapGetters } from 'vuex'
import { mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import Vue from 'vue'
import OrganizationItem from '@/components/People/OrganizationItem'
import ManageWrapperComponent from '@/components/Manage/ManageWrapperComponent'
import VueDragscroll from 'vue-dragscroll'
import ObjectiveKnob from '@/components/Okr/ObjectiveKnob'
import Objective from '@/components/Okr/Objective'
import ReadMore from '@/components/ReadMore/ReadMoreComponent'
Vue.use(VueDragscroll)

export default {
  name: 'NetWork',
  mixedins: [validationMixin],
  components: {
    // NoticeItem
    OrganizationItem,
    ManageWrapperComponent,
    ObjectiveKnob,
    Objective,
    ReadMore
  },
  props: {
    takeContent: {
      type: Object,
      default: () => ({default: true})
    },
    targetId: {
      type: String
    },
    data: {
      type: Object,
      default: () => ({contentText: ''})
    },
    nodePosition: {
      type: Object,
      default: () => ({left: 0, top: 0})
    },
    attribute: {
      // objかkeyresultを取得
      type: String
    },
    userIds: {
      type: Array
    }
  },
  data: function () {
    return {
      tag: 'NetWork',
      open: false,
      firstDown: false,
      checkedUsers: [],
      checkedGroup: [],
      deleteUsers: {},
      groupUsers: {},
      groups: {},
      searchText: '',
      groupName: '',
      oldMembers: [],
      groupOwnerId: '',
      keyResultOpen: false,
      ownerEdit: false,
      isRegistering: false,
      showModal: false,
      checkOrganization: '',
      // parentOrganization
      checkedOrganization: '',
      childGroups: {},
      depth: 1,
      moveflag: false,
      expand: false,
      checkedDepth: 0,
      content_x: 0,
      content_y: 0,
      moved_x: null,
      moded_y: null,
      target_element: null,
      mouse_over: false,
      styleMoved: {
        left: 0,
        top: 0
      },
      propShowMore: false,
      propContentHeight: 0,
      propExpandShowMore: false,
      propExpandContentHeight: 0

    }
  },
  watch: {
  },
  computed: {
    ...mapGetters('users/', [
      'getUserInfoById'
    ]),
    getNodeStyle: function () {
      if (this.nodePosition) {
        console.log('style', this.nodePosition)
        return this.nodePosition
      } else {
        return {left: 0, top: 0}
      }
    },
    userImages () {
      let images = this.userIds
        .map(x => !!this.getUserInfoById(x) && this.getUserInfoById(x).hasOwnProperty('userIcon') ? this.getUserInfoById(x).userIcon : 'static/img/noImage.png')
      return images.length > 0 ? images : ['static/img/noImage.png']
    }
    // nodeContents: function() {
    //   let nodes =  {}
    //   for (content of Object.keys(this.takeContent)) {
    //     let node = {}
    //     if(this.takeContent[content].hasOwnProperty('x')) {
    //       node.x = this.takeContent[content].x
    //     } else {
    //       node.x = 0
    //     }
    //     if(this.takeContent[content].hasOwnProperty('y')) {
    //       node.y = this.takeContent[content].y
    //     } else {
    //       node.y = 0
    //     }
    //     if(this.takeContent[content].hasOwnProperty('prev')) {
    //       console.log('準備中')
    //     }
    //     if(this.takeContent[content].hasOwnProperty('next')) {
    //       console.log('準備中')
    //     }
    //   }
    // },
  },
  mounted: function () {
    const element = document.getElementById(this.targetId)
    element.setAttribute('style', 'left:' + this.nodePosition.left + 'px;' + 'top:' + this.nodePosition.top + 'px;')
    this.styleMoved.left += this.nodePosition.left
    this.styleMoved.top += this.nodePosition.top
  },
  methods: {
    propateStyle: function () {
      this.$emit('propateStyle', {style: this.styleMoved, id: this.targetId})
    },
    mouseDownEvent: function (e) {
      this.content_x = e.pageX
      this.content_y = e.pageY
      this.mouse_over = true
      this.moveflag = true
    },
    updateShowMore: function (value) {
      this.propShowMore = value
    },
    updateContentHeight: function (value) {
      this.propContentHeight = value
    },
    updateExpandShowMore: function (value) {
      this.propExpandShowMore = value
    },
    updateExpandContentHeight: function (value) {
      this.propExpandContentHeight = value
    },
    mouseMoveEvent: function (e, targetId) {
      if (this.mouse_over) {
        this.moveflag = false
        let element = e.path[0]
        for (let targetElement of e.path) {
          if (targetElement['id'] === targetId) {
            element = targetElement
            break
          }
        }
        this.styleMoved.left += e.pageX - this.content_x
        this.styleMoved.top += e.pageY - this.content_y
        this.content_x = e.pageX
        this.content_y = e.pageY
        element.setAttribute('style', 'left:' + this.styleMoved.left + 'px;' + 'top:' + this.styleMoved.top + 'px;')
        this.$emit('propateStyle', {style: this.styleMoved, id: this.targetId})
      }
    },
    mouseUp: function (e) {
      this.mouse_over = false
      if (this.moveflag && !(e.target.classList[1] === 'openButton')) {
        this.expand = !this.expand
        this.keyResultOpen = this.expand ? this.keyResultOpen : false
      }
      this.moveflag = false
    },
    dragOver: function (e) {
      this.$emit('propateStyle', {style: this.styleMoved, id: this.targetId})
    },
    keyResultOpenButton: function () {
      this.keyResultOpen = !this.keyResultOpen
      this.moveflag = false
    }
  },
  filters: {
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div.ibox-child
span.crown-mark {
  top: 1.0rem;
  left: -1.8rem;
    /* text-shadow: 16px -6px black; */
}
.border-none {
  border: none;
}
.parentPath {
  margin-top: 8px;
}

.grab-bing {
cursor : -webkit-grab;
cursor : -moz-grab;
cursor : -o-grab;
cursor : grab;
}
.grab-bing:active {
cursor : -webkit-grabbing;
cursor : -moz-grabbing;
cursor : -o-grabbing;
cursor : grabbing;
}
#box {
    position: relative;
    width: 60%;
    height: 300px;
    overflow: hidden;
    border: 1px solid #000;
    padding:10px;
  }
.content {
  /* width: 75px;
  height: 65px;
  border: 1px solid #000;
  position: absolute;
  text-align: center;
  background-color: #fff;
  z-index: 5;
  display: block; */
  width: 150px;
  height: 100px;
  border: 1px solid #000;
  position: absolute;
  text-align: center;
  background-color: #fff;
  z-index: 2;
  display: block;
}
.expandContent {
  width: 300px;
  height: 200px;
  border: 1px solid #000;
  position: absolute;
  text-align: center;
  background-color: #fff;
  z-index: 8;
  display: block;
}
.expandContentkeyResult {
  top: 200px;
  width: 300px;
  height: 200px;
  border: 1px solid #000;
  position: absolute;
  text-align: center;
  background-color: #fff;
  z-index: 8;
  display: block;
}
.expandContentkeyResult2 {
  top: 400px;
  width: 300px;
  height: 200px;
  border: 1px solid #000;
  position: absolute;
  text-align: center;
  background-color: #fff;
  z-index: 5;
  display: block;
}
.content2 {
  width: 50px;
  height: 50px;
  border: 1px solid #000;
  position: relative;
  text-align: center;
}
.img-circle{
  width: 40px;
  height: 40px;
  position: relative;
  top: 10px;
  right: -5px;
  border: 0.2px solid rgba(0, 0, 0, 0.5);
}
.img-circle.expand {
  left: 40px;
}
.node-knob {
  right: 40px;
  top: 7px;
}
.node-knobExpand {
}
.setknob {
  display: inline-flex;
  position: relative;
}
.Heading {
  padding-top: 20px;
  position: relative;
  top: 40px;
  right: 40px;
}
.date {
  display: grid;
  padding-left: 130px;
}
.middle_card {
  display: flex;
}
.HeadingExpand {
  padding-top: 20px;
  position: relative;
  top: -10px;
  right: 0px;
}
.openButton {
  float: left;
  padding-top: 20px;
  padding-left: 20px;
  z-index: 10010
}
.user_images {
  position: relative;
}
.expandUserImages {
  position: relative;
  left: 15px;
},
.inexpand-label {
  word-break: break-all;
}
.top_card {
  padding-top:10px;
  display: flex;
}
.expandText {
  padding-top:5px;
}
.expand-setknob {
  padding-top: 20px;
}
.objective_content {
  height: 45px;
}
.other_content {
  display: -webkit-inline-flex;
  display: inline-flex;
  width: 45px;
  height: 45px;
}
</style>



// WEBPACK FOOTER //
// src/components/Okr/NetWorkContent.vue